import { Injectable } from '@angular/core';
import { ReportService } from './report.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { Filter, filterObjects, filterObjectsOnFilter } from 'na-lib';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { deepCopy } from 'na-lib';
import { operatorOptions, operatorOptionsFixedValue, typeOptions } from 'na-lib';

@Injectable({
  providedIn: 'root'
})
export class ReportFilterService {
  reportDataResults$: Subject<any> = new Subject<any>()
  reportDataResultsFiltered$= new BehaviorSubject<any[]>([])
  reportFilters$: Subject<any> = new Subject<any>()
  reportFiltersValues$: Subject<any> = new Subject<any>()

  filteredReportResults$ = new BehaviorSubject<any[]>(undefined)
  availableFilter$ = new BehaviorSubject<Map<string, Filter>>(new Map())
  selectedFilterValue$ = new BehaviorSubject<Filter[]>([])
  selectedFilters$ = new BehaviorSubject<Filter[]>([])
  reportDataResultsFilteredValues$ = new BehaviorSubject<any[]>([])
  lastReportQueryParams$ = new BehaviorSubject<any>({})

  operatorOptions = operatorOptions

  operatorOptionsFixedValue = operatorOptionsFixedValue

  typeOptions = typeOptions

  constructor(private reportService:ReportService) { 
    this.reportService.lastReportResults$.subscribe( value => {
      this.reportDataResults$.next(value)
      this.reportDataResultsFiltered$.next(value)
      this.reportDataResultsFilteredValues$.next(value)
      if(value['filters']){
       this.reportFilters$.next(value['filters'])
      }
    })

    // this.selectedFilterValue$.subscribe(value=> {
    //   this.filter()
    // })
   }


  setQueryParams(param){
    this.lastReportQueryParams$.next(param)
  }

  addQueryParam(key,value){
    let params = deepCopy( this.lastReportQueryParams$.value)
    params[key]=value
    this.lastReportQueryParams$.next(params)
  }

  clearQueryParam(key){
    let params = deepCopy( this.lastReportQueryParams$.value)
    delete params[key]
    this.lastReportQueryParams$.next(params)
  }

  clearFilter( filter, key, value){
    let allFiltersValues = this.selectedFilterValue$.value
    // if (!allFiltersValues) allFiltersValues = []
    if (allFiltersValues && allFiltersValues.length!=0) {
      const selected = allFiltersValues.find( (filt, index) => {if(filt && filt.filterKey == key) allFiltersValues.splice(index,1)})
      this.selectedFilterValue$.next(allFiltersValues)
      this.filter()
    }

  }

  activeFilter( filter, key, value){
    let allFiltersValues = this.selectedFilterValue$.value
    if (!allFiltersValues) allFiltersValues = []

    const isFilteredKey = allFiltersValues.find( id => id.filterKey == key)
    const isFiltered = allFiltersValues.find( id => id.filterKey == key &&  id.filterValue == value)

    if(isFilteredKey){
      const isFilteredDiffValue = allFiltersValues.find( id => id.filterKey == key &&  id.filterValue != value)
      if(isFilteredDiffValue){
        this.updateFilter(filter, key, value)
      }else{

      }
    }else{
      this.addFilter(allFiltersValues, filter, key, value)
    }
    
  }

  updateFilter(filter, key, value){
      let allFiltersValues = this.selectedFilterValue$.value
      // if (!allFiltersValues) allFiltersValues = []
    if (allFiltersValues) {
        // const selected = allFiltersValues.find( (filt, index) => {if(filt.filterKey == key) allFiltersValues.splice(index,1)})
        const selected = allFiltersValues.find( (filt, index) => filt.filterKey == key)
        selected.filterValue = value
        this.selectedFilterValue$.next(allFiltersValues)
        this.filter()
    }
  }

  addFilter(allFiltersValues, filter, key, value){
    var newFilter: Filter
    const operator = this.operatorOptions.find( id => id.value== filter.operator)
    const type = this.typeOptions.find( id => id.type == filter.type)
    newFilter = new Filter(filter.type, filter.key, operator, type,filter.displayName, value, filter?.description, filter?.options)
    allFiltersValues.push(newFilter)
    this.selectedFilterValue$.next(allFiltersValues)
    this.filter()
  }

  resetFilters(){
    this.selectedFilterValue$.next([])
  }

 initializeFilters( filters){
    let allFilters = []

    if(filters){
      if (filters.length >0 ){
        filters.forEach(filter => {
          var newFilter: Filter
          const operator = this.operatorOptions.find( id => id.value== filter.operator)
          const type = this.typeOptions.find( id => id.type == filter.type)
          newFilter = new Filter(filter.type, filter.key, operator, type,filter.displayName, filter?.description, filter?.options)
          allFilters.push(allFilters)
        });

        this.reportFilters$.next(allFilters)
        this.selectedFilters$.next(allFilters)
        this.selectedFilterValue$.next([])
      }
    }
    
  }

  setFilter( filter, key){
    let allFilters = this.selectedFilters$.value
    if (!allFilters) allFilters = []

    var newFilter: Filter
        const operator = this.operatorOptions.find( id => id.value== filter.operator)
        const type = this.typeOptions.find( id => id.type == filter.type)
        newFilter = new Filter(filter.type, filter.key, operator, type,filter.displayName, undefined, filter?.options)

    allFilters.push(newFilter)

    this.reportFilters$.next(allFilters)
    this.selectedFilters$.next(allFilters)
  }


   filter() {  
    if(this.selectedFilters$.value.length> 0){
      if(this.selectedFilterValue$.value.length > 0){
        const data = filterObjectsOnFilter(this.reportDataResultsFiltered$.value, this.selectedFilterValue$.value)
        this.reportDataResultsFilteredValues$.next(data)
      }else{
        this.reportDataResultsFilteredValues$.next(this.reportDataResultsFiltered$.value)
      }
    }
  }
   
}
